import PropTypes from 'prop-types';

import LanguageMenu from 'components/shared/LanguageMenu';
import Logo from 'components/svg/Logo';
import {
  AuthenticationLayoutWrapper,
  ContentWrapper,
  LanguageMenuWrapper,
  LogoWrapper,
} from './style';

const AuthenticationLayout = ({
  children,
  isLegalText,
}) => (
  <AuthenticationLayoutWrapper>
    <LanguageMenuWrapper>
      <LanguageMenu />
    </LanguageMenuWrapper>
    <LogoWrapper>
      <Logo />
    </LogoWrapper>
    <ContentWrapper isLegal={isLegalText}>
      {children}
    </ContentWrapper>
  </AuthenticationLayoutWrapper>
);

AuthenticationLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isLegalText: PropTypes.bool,
};

AuthenticationLayout.defaultProps = {
  isLegalText: false,
};

export default AuthenticationLayout;
